import api from "../Api";
import routes from "../constants/ApiRoutesConstants";

export default async function PostSupportTicket(formData) {
  const jsonData = Object.fromEntries(formData.entries());
  const res = await api.post(routes.POST_SUPPORT_TICKET, jsonData);

  return res;
}
